import { AuthenticationContext, adalFetch /*, withAdalLogin*/ } from "react-adal";
import { getAsync } from "utils/net";

const securityFeatures: {
  [key: string]: string[];
} = require("./SecurityFeatures.json");

const adalConfig = {
  tenant: "",
  clientId: "",
  cacheLocation: "localStorage",
  endpoints: {
  }
};

export let role: string;
export let authContext: any;
export let enabled = false;
export const groups = {
  security: "",
  admin: "",
  approvers: "",
};
export let anonymousUserName = "";

export const initialize = (settings: any) => {
  enabled = settings.security.enable;

  anonymousUserName = settings.security.anonymousUserName;
  role = settings.security.anonymousRole;

  if (enabled) {
    adalConfig.tenant = settings.security.tenant;
    adalConfig.clientId = adalConfig.endpoints[document.location.origin] = settings.security.clientId;

    groups.security = settings.security.securityGroupId;
    groups.admin = settings.security.adminGroupId;
    groups.approvers = settings.security.approversGroupId;

    authContext = new AuthenticationContext(adalConfig);
  }
};

export const getUserName = () => {
  return authContext ? authContext._user.userName : anonymousUserName;
}

export const getUserRoleAsync = async () => {
  if (enabled) {
    const upn = getUserName();
    const reply = await getAsync(`/api/UserManagement/${upn}`);
    const payload = await reply.text();
    role = payload;
  }
}

export const checkRole = (feature: string) => {
  const enabledRoles = securityFeatures[feature];
  return enabledRoles && enabledRoles.some(r => r === role)
};

export const checkUser = (s: string | undefined) => {
  return getUserName() === s;
};

export const adalApiFetch = (url: string, options?: RequestInit) =>
  enabled
    ? adalFetch(authContext, adalConfig.endpoints[document.location.origin], fetch, url, options) :
    fetch(url, options);



// WEBPACK FOOTER //
// ./src/security/security.ts